/** Must stay aligned with AIAssistantCommand.MaximumMessageCharacters. */
export const MAXIMUM_ASSISTANT_MESSAGE_CHARACTERS = 8_000;

import { AssistantScreenContext } from "ai-assistant/screen-context/assistant-screen-context";

export default class AssistantAPICommand {
  public message?: string;
  public conversationId?: string;
  public currentRoute?: string;
  public screenContext?: AssistantScreenContext;
  /** The browser's IANA time zone, so "last month" and "by quarter" fall on the user's calendar. */
  public timeZone?: string;
  /** Files uploaded beforehand that this message carries (#6504). At most five. */
  public attachmentIds?: string[];
  /** An id the panel made for this turn, so it can tell this turn's live steps from any other's (#7286). */
  public turnId?: string;
}
